module.exports = __webpack_public_path__ + "img/tz7.e1765d6c.jpg";